<template>
  <pt-paid-order-list class="pt-paid-order-list__page"></pt-paid-order-list>
</template>

<script>
import PtPaidOrderList from 'cps/goods-order/pt-paid-order-list/withData'
export default {
  name: 'pt-paid-order-list__view',
  components: {
    'pt-paid-order-list': PtPaidOrderList
  }
}
</script>
